import React from 'react';
import { PolaGroupSection } from '../components/PolaGroupSection';
import { SolutionsSection } from '../components/SolutionsSection';
export function AboutPage() {
  return <div className="pt-28" data-id="element-598">
      <PolaGroupSection data-id="element-599" />
      <SolutionsSection data-id="element-600" />
    </div>;
}